/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiYAxisChartType;
(function (ApiYAxisChartType) {
    ApiYAxisChartType["BAR"] = "Y_AXIS_CHART_TYPE_BAR";
    ApiYAxisChartType["LINE"] = "Y_AXIS_CHART_TYPE_LINE";
    ApiYAxisChartType["AREA"] = "Y_AXIS_CHART_TYPE_AREA";
    ApiYAxisChartType["DOT"] = "Y_AXIS_CHART_TYPE_DOT";
})(ApiYAxisChartType || (ApiYAxisChartType = {}));
export function ApiYAxisChartTypeFromJSON(json) {
    return ApiYAxisChartTypeFromJSONTyped(json, false);
}
export function ApiYAxisChartTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiYAxisChartTypeToJSON(value) {
    return value;
}
